__turbopack_context__.v({
  "boxFirst": "bento-three-squares-module-scss-module__6ElX9W__boxFirst",
  "boxFirstContainer": "bento-three-squares-module-scss-module__6ElX9W__boxFirstContainer",
  "boxOneContent": "bento-three-squares-module-scss-module__6ElX9W__boxOneContent",
  "boxThreeContent": "bento-three-squares-module-scss-module__6ElX9W__boxThreeContent",
  "boxTwoContent": "bento-three-squares-module-scss-module__6ElX9W__boxTwoContent",
  "container": "bento-three-squares-module-scss-module__6ElX9W__container",
  "flexContainer": "bento-three-squares-module-scss-module__6ElX9W__flexContainer",
});
